import Vue from 'vue'
import Vuex from 'vuex'
import cookie from 'js-cookie'
import md5 from 'js-md5'
Vue.use(Vuex)
import {webSiteConfig} from '@/api';
const store = new Vuex.Store({
    // this.$store.state.hasLogin
    state: {
        hasLogin: false,
        token: null,
        userInfo: {},
        swiper: false,
        websiteInfo:null,
        nvaActive:"start"
    },
    //唯一修改 state 的方式
    mutations: {
        // this.$store.commit('login',res.data)
        login(state, provider) {
            state.hasLogin = true;
            // console.log(JSON.stringify(provider))
            state.userInfo = provider.userInfo
            state.token = provider.token
            // MD5加盐
            // let md5Obj=md5(JSON.stringify(provider.userInfo))
            // cookie.set("userInfo",md5Obj,6);
            // cookie.set("userToken",provider.token,6);
            // console.log("缓存：登录")
        },
        // this.$store.commit('logout')
        logout(state) {
            console.log('缓存：退出了')
            state.hasLogin = false
            state.token = null
            state.userInfo = {}
            cookie.remove('userToken')
            cookie.remove('userInfo')
        },
        setSwiper: (state, payload) => {
            state.swiper = payload.swiper
        },
        setWebsiteInfo(state, websiteInfo) {
            console.log("=========init websiteInfo===========")
            state.websiteInfo = websiteInfo
        },
        setNavActive(state, navActive) {
            state.nvaActive = navActive
        }
    },
    //处理异步操作，提交 mutation 来修改 state
    actions: {
        async initWebsite() {
            webSiteConfig({}).then(res => {
                store.commit('setWebsiteInfo', res.data)
            })
        }
    },
    modules: {},
    // 可逻辑处理后返回一个对象
    getters:{
        getWebsiteInfo(state){
            return state.websiteInfo
        }
    }
})

export default store
